export default __webpack_public_path__ + "static/media/Group683.9fd0c6dc.svg";